/**
 * Created by mark on 17/12/2017.
 */

import BaseStore from './base-store.js';
import Constants from '../constants.js';

var _registerToActions = function(action){

    console.log(action)

    switch(action.actionType)
    {
        case Constants.GET_ACCOUNT_RESULTS:
            this.accountResults = action.response
            this.emit(Constants.GET_ACCOUNT_RESULTS);
            break;
    }

};

class ExamResultsStore extends BaseStore{

    constructor(){
        super();
        this.subscribe(() => _registerToActions.bind(this));
        this.languages =  [];
    }

}

export default new ExamResultsStore();